import {Component, OnInit} from '@angular/core';
import {Location} from '@angular/common';
import {Router} from '@angular/router';
import {CompleterService, CompleterData, CompleterItem} from 'ng2-completer';
import {StartService} from './start.service';
import { CITIES } from '../../constants/cities';
import { Information } from './information';

@Component({
    selector: 'start',
    template: require('./start.component.html'),
    providers: [ CompleterService, StartService]
})

export class SuperUserStartComponent implements OnInit {
    emailValidation: boolean;
    userProperties: boolean;
    paymentValidation: boolean;
    conditionsValidation: boolean;
    citySelected: number;
    emailSent: boolean;
    category: number;
    accountType: number;
    paymentMethod: number;
    paymentPosted: boolean;
    printMode: boolean;
    errorCodes: any = [];
    router: Router;

    showTerms = false;

    classMapModal: any;

    search_city = "Ciutat";
    city_not_found = "Ciutat no trobada";

    model = new Information("", "", "", "", "");

    paymentParams = {
        "parameters": "",
        "signature": "",
        "signatureVersion": "",
        "id": 0,
        "code": "",
        "amount": ""
    };

    private searchStr: string;
    private dataService: CompleterData;

    constructor(private _startService: StartService, private _completerService: CompleterService, location: Location, _parentRouter: Router) {
        this.router = _parentRouter;
        this.emailValidation = false;
        this.userProperties = false;
        this.dataService = this._completerService.local(CITIES, 'name', 'name');
        this.accountType = 0;
        this.paymentMethod = 0;
        this.paymentPosted = false;
        this.printMode = false;
        this.category = 0;
        this.classMapModal = { 'model': true, 'show': false, 'hide': true };
    }

    ngOnInit() {
        this._startService.userProperties().then(data => {
            if(data.active==1) {                
                this.router.navigate(['/superuser', 'dashboard']);
            }
            this.emailValidation = (data.email_active == 1);
            this.userProperties = (data.info == 1);
            this.paymentValidation = (data.payment == 1 || data.payment == 2 || data.payment == 3);
            this.conditionsValidation = (data.terms == 1);
        });

    }


    public onCitySelected(selected: CompleterItem) {
        this.citySelected = selected.originalObject.id;
    }

    public acceptTerms(event: Event) {
        this._startService.acceptTerms().then(data => { this.conditionsValidation = true; });
    }

    public resendEmail() {
        this._startService.resendEmail().then(data => { this.emailSent = true; });
    }

    public changeAccountType(type: number) {
        this.accountType = type;
    }

    public changePaymentMethod(method: number) {
        if (this.paymentMethod == 0) {
            this._startService.createTransaction(this.accountType, method).then(
                res => {
                    this.paymentParams.parameters = res.PARAMS;
                    this.paymentParams.signature = res.SIGNATURE;
                    this.paymentParams.signatureVersion = res.VERSION;
                    this.paymentParams.code = res.TRANSACTION_CODE;
                    this.paymentParams.id = res.TRANSACTION_ID;
                    this.paymentParams.amount = res.TRANSACTION_AMOUNT;
                    this.paymentMethod = method;
                }
            );
        }
        else if (method == this.paymentMethod) { }
        else {
            this._startService.updateTransaction(this.paymentParams.id, method).then(
                res => {
                    this.paymentMethod = method;
                }
            );
        }
    }

    public submitPayment() {
        if (this.paymentMethod == 1) {
            this.paymentPosted = true;
        }
        else if (this.paymentMethod == 2) {

        }
        else {

        }
    }

    onSubmit(value: any) {
                        
        var cities = CITIES.filter(city => city.name.toLowerCase() == value.city.toLowerCase());

        if(cities.length != 0 && cities[0] !== undefined && cities[0] !== null) {

            value.city = cities[0].name;
            value.city_id = cities[0].id;
            this.citySelected = cities[0].id;            

        }        

        value.category = this.category;
        if (this.checkParams(value)) {
            if (value.email != "") {
                this._startService.existsEmail(value.email).then(
                    res => {
                        if (!res) {
                            this.errorCodes.push(552);
                        }
                        else {
                            this.submitInformation(value);
                        }
                    });
            }
            else {
                this.submitInformation(value);
            }
        }
    }

    private submitInformation(value: any) {
        this._startService.postInformation(value)
            .subscribe(
            (result) => {
                if (result == 1) {
                    this.userProperties = true;
                }
            },
            () => { }
            );
    }

    codeError(code: any) {
        var found = false;
        var i = 0;

        while (!found && i < this.errorCodes.length) {
            if (code == this.errorCodes[i]) {
                found = true;
            }
            i++;
        }
        return found;
    }

    private checkParams(value: any) {
        this.errorCodes = [];
        //email check
        if (value.phone.length === 0) {
            this.errorCodes.push(543);
        }
        else if (!this.validPhone(value.phone)) {
            this.errorCodes.push(544);
        }

        if (value.address.length === 0) {
            this.errorCodes.push(545);
        }
        else if (value.address.length < 5) {
            this.errorCodes.push(546);
        }
        else if (value.address.length > 120) {
            this.errorCodes.push(547);
        }

        if (value.zip.length === 0) {
            this.errorCodes.push(548);
        }
        else if (!this.validZip(value.zip)) {
            this.errorCodes.push(549);
        }

        if (value.city.length === 0) {
            this.errorCodes.push(550);
        }
        else if (!this.existsCity(value.city)) {
            this.errorCodes.push(551);
        }
        console.log(value.category);
        if (value.category == 0) {
            this.errorCodes.push(553);
        }

        if (this.errorCodes.length > 0) {
            if (value.email != "") {
                this._startService.existsEmail(value.email).then(res => {
                    if (!res) {
                        this.errorCodes.push(552);
                    }
                });
            }
        }
        return this.errorCodes.length === 0;
    }

    public registerFree() {
        this._startService.registerFree()
            .subscribe(
            (result) => {
                if (result == 1) {
                    this.paymentValidation = true;
                }
            },
            () => { }
            );
    }

    private validPhone(phone: string) {
        var re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{3,6}$/im;
        var re2 = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{2}[-\s\.]?[0-9]{2}[-\s\.]?[0-9]{2}$/im;
        return re.test(phone) || re2.test(phone);

    }

    private existsCity(city: string) {
        for (var i = 0; i < CITIES.length; i++) {
            if (CITIES[i].id == this.citySelected) {
                if (CITIES[i].name == city) return true;
                else return false;
            }
        }
        return false;
    }

    private validZip(zip: string) {
        var re = /^[\+]?[(]?[0-9]{5}$/im;
        return re.test(zip);
    }

    changeCategory(category: number) {
        this.category = category;
    }

    public printBankTransfer() {
        this.printMode = !this.printMode;
    }

    public enterDashboard() {
        this._startService.enterDashboard().then(
            res => {
                if (res) {
                    this.router.navigate(['/superuser', 'dashboard']);
                }

            });
    }

    public showTermsF() {
        if(!this.classMapModal.show) {
            this.classMapModal.show = true;
            this.classMapModal.hide = false;
        }
        else {
            this.classMapModal.show = false;
            this.classMapModal.hide = true;
        }
    }

    public closeModal() {
        this.showTermsF();
    }
}





/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/super_user/start/start.component.ts
 **/